import { __awaiter, __generator } from "tslib";
import { getUserStorageItem, setUserStorageItem, } from '@office-start/user-storage-service';
var COPILOT_USER_STORAGE_KEY = 'CopilotPinUserState';
export function getUserStorageOptions(componentContext) {
    var correlationId = componentContext.correlationId, getAccessToken = componentContext.getAccessToken, getIdentity = componentContext.getIdentity, _a = componentContext.inMockMode, inMockMode = _a === void 0 ? false : _a, _b = componentContext.jwtAuthEnabled, jwtAuthEnabled = _b === void 0 ? false : _b, _c = componentContext.officeHomeApiRoot, officeHomeApiRoot = _c === void 0 ? '' : _c, workload = componentContext.workload;
    return {
        correlationId: correlationId,
        getAccessToken: getAccessToken,
        getIdentity: getIdentity,
        inMockMode: inMockMode,
        jwtAuthEnabled: jwtAuthEnabled,
        officeHomeApiRoot: officeHomeApiRoot,
        workload: workload,
    };
}
export var userCopilotFreDataDefault = {
    ShouldShowWelcomeFre: true,
    PinFREShowCount: 0,
    HasAdminPinnedWorkFlowRan: false,
    HasUserPinnedWorkFlowRan: false,
    CopilotFreStatus: 0,
    LastCopilotFreDisplayTimestamp: new Date(0).toISOString(),
};
export function getCopilotPinUserData(userStorageOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserStorageItem(COPILOT_USER_STORAGE_KEY, userStorageOptions)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result !== null && result !== void 0 ? result : userCopilotFreDataDefault];
            }
        });
    });
}
export function setCopilotPinUserData(userData, userStorageOptions) {
    return setUserStorageItem(COPILOT_USER_STORAGE_KEY, userData, userStorageOptions);
}
//# sourceMappingURL=utilities.js.map